import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CouponConfirmTemplate } from 'components/Templates'

const CouponConfirm: FC = () => {
  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'確認 | 新規クーポン作成'}>
      <CouponConfirmTemplate />
    </Layout>
  )
}

export default CouponConfirm
